<template lang="pug">
#loading
    VueElementLoading(
        :active='mostrarLoading',
        :is-full-screen='true',
        spinner='bar-fade-scale',
        color='var(--color-loading)',
        :text='mensagem'
    )
</template>

<script>
import VueElementLoading from 'vue-element-loading';
import EventBus from '@/utils/eventBus';

export default {
    components: {
        VueElementLoading
    },
    data() {
        return {
            mostrarLoading: false,
            mensagem: 'Carregando'
        };
    },
    created() {
        EventBus.$on(
            'emit-componente-carregando',
            ({ mostrarLoading, lockMessage }) => {
                this.mostrarLoading = mostrarLoading;
                this.mensagem = lockMessage || 'Carregando';
            }
        );
    }
};
</script>
